export const formatCurrency = (value) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(Number(value) || 0);

export const prettyStatus = (status = "placed") => status.replaceAll("_", " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
